import _defineProperty from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _toConsumableArray from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _classCallCheck from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _assertThisInitialized from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js";
import _inherits from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";
import _classPrivateFieldGet from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/classPrivateFieldGet.js";
import _classPrivateFieldSet from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/classPrivateFieldSet.js";
var _queries;
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _classPrivateFieldInitSpec(obj, privateMap, value) { _checkPrivateRedeclaration(obj, privateMap); privateMap.set(obj, value); }
function _checkPrivateRedeclaration(obj, privateCollection) { if (privateCollection.has(obj)) { throw new TypeError("Cannot initialize the same private elements twice on an object"); } }
// src/queryCache.ts
import { hashQueryKeyByOptions, matchQuery } from "./utils.js";
import { Query } from "./query.js";
import { notifyManager } from "./notifyManager.js";
import { Subscribable } from "./subscribable.js";
var QueryCache = (_queries = /*#__PURE__*/new WeakMap(), /*#__PURE__*/function (_Subscribable) {
  _inherits(QueryCache, _Subscribable);
  var _super = _createSuper(QueryCache);
  function QueryCache() {
    var _this;
    var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    _classCallCheck(this, QueryCache);
    _this = _super.call(this);
    _classPrivateFieldInitSpec(_assertThisInitialized(_this), _queries, {
      writable: true,
      value: void 0
    });
    _this.config = config;
    _classPrivateFieldSet(_assertThisInitialized(_this), _queries, /* @__PURE__ */new Map());
    return _this;
  }
  _createClass(QueryCache, [{
    key: "build",
    value: function build(client, options, state) {
      var _options$queryHash;
      var queryKey = options.queryKey;
      var queryHash = (_options$queryHash = options.queryHash) !== null && _options$queryHash !== void 0 ? _options$queryHash : hashQueryKeyByOptions(queryKey, options);
      var query = this.get(queryHash);
      if (!query) {
        query = new Query({
          cache: this,
          queryKey: queryKey,
          queryHash: queryHash,
          options: client.defaultQueryOptions(options),
          state: state,
          defaultOptions: client.getQueryDefaults(queryKey)
        });
        this.add(query);
      }
      return query;
    }
  }, {
    key: "add",
    value: function add(query) {
      if (!_classPrivateFieldGet(this, _queries).has(query.queryHash)) {
        _classPrivateFieldGet(this, _queries).set(query.queryHash, query);
        this.notify({
          type: "added",
          query: query
        });
      }
    }
  }, {
    key: "remove",
    value: function remove(query) {
      var queryInMap = _classPrivateFieldGet(this, _queries).get(query.queryHash);
      if (queryInMap) {
        query.destroy();
        if (queryInMap === query) {
          _classPrivateFieldGet(this, _queries).delete(query.queryHash);
        }
        this.notify({
          type: "removed",
          query: query
        });
      }
    }
  }, {
    key: "clear",
    value: function clear() {
      var _this2 = this;
      notifyManager.batch(function () {
        _this2.getAll().forEach(function (query) {
          _this2.remove(query);
        });
      });
    }
  }, {
    key: "get",
    value: function get(queryHash) {
      return _classPrivateFieldGet(this, _queries).get(queryHash);
    }
  }, {
    key: "getAll",
    value: function getAll() {
      return _toConsumableArray(_classPrivateFieldGet(this, _queries).values());
    }
  }, {
    key: "find",
    value: function find(filters) {
      var defaultedFilters = _objectSpread({
        exact: true
      }, filters);
      return this.getAll().find(function (query) {
        return matchQuery(defaultedFilters, query);
      });
    }
  }, {
    key: "findAll",
    value: function findAll() {
      var filters = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var queries = this.getAll();
      return Object.keys(filters).length > 0 ? queries.filter(function (query) {
        return matchQuery(filters, query);
      }) : queries;
    }
  }, {
    key: "notify",
    value: function notify(event) {
      var _this3 = this;
      notifyManager.batch(function () {
        _this3.listeners.forEach(function (listener) {
          listener(event);
        });
      });
    }
  }, {
    key: "onFocus",
    value: function onFocus() {
      var _this4 = this;
      notifyManager.batch(function () {
        _this4.getAll().forEach(function (query) {
          query.onFocus();
        });
      });
    }
  }, {
    key: "onOnline",
    value: function onOnline() {
      var _this5 = this;
      notifyManager.batch(function () {
        _this5.getAll().forEach(function (query) {
          query.onOnline();
        });
      });
    }
  }]);
  return QueryCache;
}(Subscribable));
export { QueryCache };